<label
  class="atlas-navbar__slide-toggle__label"
  [class.atlas-navbar__slide-toggle__label--checked]="value"
  [class.atlas-navbar__slide-toggle__label--default]="color === 'default'"
  [class.atlas-navbar__slide-toggle__label--primary]="color === 'primary'"
  [class.atlas-navbar__slide-toggle__label--secondary]="color === 'secondary'"
  [class.atlas-navbar__slide-toggle__label--disabled]="disabled"
>
  <div class="atlas-navbar__slide-toggle-bar">
    <input
      class="atlas-navbar__slide-toggle__input"
      type="checkbox"
      role="switch"
      [checked]="value"
      (change)="value = !value"
      [disabled]="disabled"
    />
    <div class="atlas-navbar__slide-toggle__thumb-container">
      <div class="atlas-navbar__slide-toggle__thumb"></div>
      <div class="atlas-navbar__slide-toggle__overlay">
        <div class="atlas-navbar__slide-toggle__overlay__element"></div>
      </div>
    </div>
  </div>
  <span class="atlas-navbar__slide-toggle__content">{{ label }}</span>
</label>
